<h1 mat-dialog-title>Gerar canhotos</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: '350px';">
  <form [formGroup]="canhotosForm">
    <div class="borda">
      <div class="row">
        <div class="col-sm">
          {{f.quantidade.value}} recibo(s) - 1 para cada pedido com forma de pagamento 'Boleto'.
        </div>
      </div>
    </div>
  </form>

  <mat-divider></mat-divider>

  <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
    <button mat-flat-button color="warn" (click)="cancelar()">
      <mat-icon>clear</mat-icon> Cancelar
    </button>
    <button mat-flat-button color="primary" (click)="confirmarGerarCanhotos()">
      <mat-icon>print</mat-icon> Imprimir
    </button>
  </section>
</div>
